import { t } from "i18next";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../app/hooks";
import { store } from "../../app/store";
import { Footer } from "../../screens/Footer/Footer";
import MasterClassActivityTailComponent from "../../ui/components/ActivityTail/MasterClassActivityTail";
import { MasterClassFilterBar } from "../../ui/components/FilterBar/MasterClassFilterBar";
import MyOrders from "../../ui/components/MyOrders/MyOrders";
import { IconClose } from "../../ui/components/icons/IconClose";
import { IconTik } from "../../ui/components/icons/IconTik";
import { TwentyIcLesson } from "../../ui/components/icons/TwentyIcLesson";
import {
  MyOrder,
  getAllOrdersAsync,
  myOrdersElementOrderedEmptyState,
  myOrdersSelector,
  selectMyOrdersSliceElementOrdered,
} from "../myorders/MyOrdersSlice";
import "./MasterClass.css";
import {
  MasterClassActivityTail,
  getMasterClassActivityTailAsync,
  masterClassActivityTailSelector,
} from "./MasterClassActivityTailSlice";
import { number } from "prop-types";
import { useParams } from "react-router-dom";

export const MasterClass = () => {
  const [switchSelected, setSwitchSelected] = useState<number>(0);
  const elementsLimit = 3;
  const [liked, setLiked] = useState(false);
  const masterClasses: MasterClassActivityTail[] = useAppSelector(
    masterClassActivityTailSelector.selectAll
  );
  let elementOrderedId = useAppSelector(selectMyOrdersSliceElementOrdered);
  const myOrders: MyOrder[] = useAppSelector(myOrdersSelector.selectAll);
  const [elementOrderData, setElementOrderData] =
    useState<MasterClassActivityTail>();
  let refresh = false;



  useEffect(() => {
    if (!refresh) {
      if (masterClasses.length === 0) {
        store.dispatch(getMasterClassActivityTailAsync({}));
      }
      if (myOrders.length === 0) {
        store.dispatch(getAllOrdersAsync({ queryString: "?type=masterClass" }));
      }
      refresh = true;
    }
  }, []);

  useEffect(() => {
    if (elementOrderData) {
      setSwitchSelected(1); 
    }
  }, [elementOrderData]);

  useEffect(() => {
    if (elementOrderedId !== 0) {
      let elementOrderedData =
        masterClasses.find(
          (el) =>
            el.id ===
            myOrders.find((e) => e.id === elementOrderedId)?.masterClassId
        ) ?? ({} as MasterClassActivityTail);
      setElementOrderData(elementOrderedData);
    }
  }, [elementOrderedId]);

  useEffect(() => {
    switchSelected &&
      store.dispatch(getAllOrdersAsync({ queryString: "?type=masterClass" }));
  }, [switchSelected]);

  function fillEmptyActivityTailsResults(counter: number): JSX.Element[] {
    var elements = [];
    for (var i = 0; i < elementsLimit - counter; i++) {
      elements.push(
        <div className="masterclass-activitytail-transparent-container">
          <MasterClassActivityTailComponent
            id={undefined}
            placesLeft={undefined}
            startDate={new Date()}
            endDate={new Date()}
            city={undefined}
            image={undefined}
            title={undefined}
            isFavorite={false}
            reactionButton={() => {}}
          />
        </div>
      );
    }
    return elements;
  }
  function fillMyOrdersResults(orders: MyOrder[]): JSX.Element[] {

    let elements = [];
    if (!!orders) {
      for (let i = 0; i < orders.length; i++) {
        let temp = masterClasses.find(
          (el) => el.id === orders[i].masterClassId
        );
        elements.push(
          <React.Fragment key={orders[i].id}>
            <MyOrders
              id={orders[i].id}
              date={orders[i].bookingDate}
              price={temp?.price?.toString()}
              image={temp?.image}
              status={orders[i].status.toString()}
              titleOne={temp?.title}
              titleTwo={""}
              personsNumber={orders[i].numberOfPeople}
              masterClassId={orders[i].masterClassId}
              type={"MasterClass"}
              deposit={temp?.deposit?.toString()}
              profilePhoto={orders[i].profilePhoto}
              prenotazione={orders[i].prenotazione}
            />
          </React.Fragment>
        );
      }
    }
    return elements;
  }
  
  const requestOrders = myOrders.filter((order) => order.status === 1);

  const pendingPurchasedOrders = myOrders.filter((order) => order.status !== 1);

  function fillActivityTailsResults(): JSX.Element[] {
    var elements = [];
    if (!!masterClasses) {
      for (let i = 0; i < Math.ceil(masterClasses.length / 3); i++) {
        var children = [];
        var columnCounter = 0;
        for (
          let j = i * elementsLimit;
          j < masterClasses.length && columnCounter < elementsLimit;
          j++
        ) {
          children.push(
            <React.Fragment>
              <MasterClassActivityTailComponent
                id={masterClasses[j].id}
                image={masterClasses[j].image}
                startDate={masterClasses[j].startDate}
                endDate={masterClasses[j].endDate}
                city={masterClasses[j].city}
                title={masterClasses[j].title}
                placesLeft={masterClasses[j].placesLeft}
                isFavorite={false}
                reactionButton={() => {
                  setLiked(!liked);
                }}
                arrow={true}
              />
            </React.Fragment>
          );
          columnCounter++;
        }
        children.push(fillEmptyActivityTailsResults(columnCounter));
        elements.push(
          <div className="masterclass-activitytail-container-row">
            {children}
          </div>
        );
      }
      return elements;
    }
    return [];
  }

  return (
    <>
      <div className="masterclass-content">
        <div className="frame-16">
          <div className="frame-17">
            <div className="masterclass-topbar">
              <div className="masterclass-topbar-title-iconplace">
                <TwentyIcLesson
                  className="masterclass-topbar-title-iconplace-icon"
                  color="#36B39E"
                />
              </div>
              <div className="masterclass-topbar-title">
                {t("masterClass.common.masterclass")}
              </div>
            </div>
          </div>
        </div>

        {/* Filter Bar */}
        <MasterClassFilterBar
          switchStatus={switchSelected}
          setSwitchSelected={(value) => setSwitchSelected(value)}
        />

        {/* Show the success message for completed orders */}
        {!_.isEmpty(elementOrderData) && (
          <div className="masterclass-ordersuccess-container">
            <div className="masterclass-ordersuccess-textcontainer">
              <IconTik className={undefined} />
              <div className="masterclass-ordersuccess-text">
                {t("myOrders.masterOrderCompleted").replace(
                  "*masterName",
                  elementOrderData ? elementOrderData.title : ""
                )}
              </div>
            </div>
            <div
              className="masterclass-ordersuccess-icon"
              onClick={() => {
                setElementOrderData(undefined);
                store.dispatch(myOrdersElementOrderedEmptyState());
              }}
            >
              <IconClose
                className={undefined}
                onClick={undefined}
                color={undefined}
              ></IconClose>
            </div>
          </div>
        )}

        {/* Show results title */}
        {((!switchSelected && masterClasses.length > 0) ||
          (switchSelected && myOrders.length > 0)) && (
          <div className="masterclass-activitytail-results-bar">
            <div className="masterclass-activitytail-results-title">
              <div className="masterclass-activitytail-results-title-one">
                {t("masterClass.common.results")}
              </div>
              <div className="masterclass-activitytail-results-title-two">
                (
                {switchSelected === 0
                  ? masterClasses.length
                  : switchSelected === 1
                  ? requestOrders.length
                  : pendingPurchasedOrders.length}
                )
              </div>
            </div>
          </div>
        )}

        {/* Content for each tab */}
        {switchSelected === 0 && (
          // Tab 0 - Tutte le Masterclass
          <div className="masterclass-activitytail-container">
            {masterClasses.length === 0 ? (
              <div className="masterclass-noelements-container">
                <div className="masterclass-noelement-container-slide">
                  <div className="masterclass-noelement-container-slide-icon">
                    <TwentyIcLesson
                      tail="m"
                      color="#222729"
                      className={undefined}
                    />{" "}
                  </div>
                  <div className="masterclass-noelement-container-slide-text">
                    <div className="masterclass-noelement-container-slide-textone">
                      {t("masterClass.common.noResultsTextone")}
                    </div>
                    <div className="masterclass-noelement-container-slide-texttwo">
                      {t("masterClass.common.noResultsTexttwo")}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              fillActivityTailsResults()
            )}
          </div>
        )}

        {switchSelected === 1 && (
          // Tab 1 - Richieste in Corso)
          <div className="masterclass-activitytail-container">
            {requestOrders.length === 0 ? (
              <div className="masterclass-myorderempty-container">
                <div className="masterclass-myorderempty-element">
                  <TwentyIcLesson
                    tail="m"
                    color="#222729"
                    className={"masterclass-myorderempty-icon"}
                  />
                  <div className="masterclass-myorderempty-firsttext">
                    {t("masterClass.common.ordersEmptyTextThree")}
                  </div>
                  <div className="masterclass-myorderempty-secondtext">
                    {t("masterClass.common.ordersEmptyTextTwo")}
                  </div>
                </div>
              </div>
            ) : (
              fillMyOrdersResults(requestOrders)
            )}
          </div>
        )}

        {switchSelected === 2 && (
          // Tab 2 - Acquistati ("In attesa di pagamento", mostra gli altri ordini)
          <div className="masterclass-myorder-container">
            {pendingPurchasedOrders.length > 0 ? (
              fillMyOrdersResults(pendingPurchasedOrders)
            ) : (
              <div className="masterclass-myorderempty-container">
                <div className="masterclass-myorderempty-element">
                  <TwentyIcLesson
                    tail="m"
                    color="#222729"
                    className={"masterclass-myorderempty-icon"}
                  />
                  <div className="masterclass-myorderempty-firsttext">
                    {t("masterClass.common.ordersEmptyTextOne")}
                  </div>
                  <div className="masterclass-myorderempty-secondtext">
                    {t("masterClass.common.ordersEmptyTextTwo")}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      <Footer />
    </>
  );
};
